import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'

const PILLS = [
  { to: '/profile/personal', label: 'Personal' },
  { to: '/profile/address', label: 'Address' },
  { to: '/profile/tags', label: 'Tags' },
  { to: '/profile/family', label: 'Family' },
  { to: '/profile/education', label: 'Education' },
  { to: '/profile/employment', label: 'Employment' },
  { to: '/profile/organizations', label: 'Orgs' },
  { to: '/profile/documents', label: 'Docs' },
]

export function ProfilePillBar() {
  return (
    <div className="mb-4 -mx-4 overflow-x-auto px-4 scrollbar-none">
      <div className="flex gap-2 pb-1">
        {PILLS.map((pill) => (
          <NavLink
            key={pill.to}
            to={pill.to}
            className={({ isActive }) => cn(
              'shrink-0 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors',
              isActive
                ? 'border-primary bg-primary text-primary-foreground'
                : 'border-input bg-background text-muted-foreground hover:bg-accent'
            )}
          >
            {pill.label}
          </NavLink>
        ))}
      </div>
    </div>
  )
}
